module.exports = __webpack_public_path__ + "static/media/freetext-pn.23994d79.png";